import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import {
  submitCaseInitiation,
  SubmitCaseInitiationPayload,
} from "../../../../api/postCall/submitCaseInitiation";
import { ToastMessages } from "../../../../enums/toastMessages";
import { logError } from "../../../../utils/customLogger";
import { CaseInitiationFormData } from "../hooks/useCaseInitiationForm";

/**
 * Handles the case initiation submission (fire and forget)
 * @param formData - The form data from the modal
 * @param orgId - The organization ID
 * @param onSuccess - Callback to execute after successful submission
 */
export const onSaveCaseInitiation = (
  formData: CaseInitiationFormData,
  orgId: string,
  onSuccess: () => void,
): void => {
  const payload: SubmitCaseInitiationPayload = {
    mrn: formData.mrn,
    dob: formData.caseDate,
    first_name: formData.firstName,
    last_name: formData.lastName,
    prescriber_name: formData.prescriberName,
    drug: formData.drugName,
    key: formData.key,
    org_id: orgId,
  };

  // Show success toast immediately (fire and forget)
  toast.success(ToastMessages.CASE_INITIATION_SUBMIT_SUCCESS);
  onSuccess();

  // Fire and forget - don't await the response
  submitCaseInitiation(payload)
    .then((response) => {
      if (!response.success) {
        console.error("Case initiation failed:", response.message);
      }
    })
    .catch((error) => {
      logError(error as Error, "Error submitting case initiation");
    });
};
